export default __webpack_public_path__ + "static/media/Aziz_Abaza.f850cf20.jpg";